import { type PropsWithChildren } from "react";

interface Props {
  onClose: () => void;
}

export const DetailsPanelWrapper = ({
  children,
  onClose,
}: PropsWithChildren<Props>) => {
  return (
    <div className="text-xs py-2.5 px-3">
      <button
        className="text-primary font-semibold hover:bg-cosmic-5 pb-1"
        onClick={onClose}
      >
        <i className="fa-regular fa-sharp fa-arrow-left text-primary mr-1"></i>
        BACK
      </button>
      {children}
    </div>
  );
};
